import { render } from "./ybDuiZhangView.vue?vue&type=template&id=51ce90c8"
import script from "./ybDuiZhangView.vue?vue&type=script&lang=js"
export * from "./ybDuiZhangView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PDM-小程序\\HSM_PDM\\PDM_Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QInput,QBtn,QSpace});
